/* eslint-disable no-shadow */

export enum BalanceTypes {
  eCredits = 'ecredits',
  eActivity = 'eactivity',
  euro = 'euro',
  blockTrade = 'blocktrade',
  ether = 'ether',
  other = 'other',
  eVault = 'evault',
}

export enum UserRoles {
  owner = 'o',
  manager = 'm',
  viewer = 'v',
  cashier = 'c',
  developer = 'd',
}

export enum InvitationStatuses {
  sentInvitations,
  acceptedInvitations,
  onboardingBusinesses,
  rewardsFromBusinesses,
}

export enum CashbackTypes {
  cashback = 'Cashback',
  compensation = 'Compensation',
}

export enum ErrorTypes {
  none = 'None',
  ledger = 'Ledger',
  backend = 'Backend',
}

export enum PaymentMethods {
  ecredits = 'ECredits',
  creditcard = 'CreditCard',
  voucher = 'Voucher',
}

export enum RefundRequestStatuses {
  pending = 'pending',
  confirmed = 'confirmed',
  rejected = 'rejected',
  multiPayment = 'multiPayment',
  error = 'error',
}

export enum TransactionsStatuses {
  confirmed = 'Confirmed',
  failed = 'Failed',
}

export enum ApplicationRouteSegments {
  root = '/',
  dashboard = 'dashboard',
  transactions = 'transactions',
  stores = 'stores',
  storeDetails = 'details',
  storeAddress = 'address',
  storeOpeningHours = 'openinghours',
  selectStore = 'selectstore',
  addStore = 'addstore',
  details = 'details',
  invitationmanagement = 'invitationmanagement',
  subscriptions = 'subscriptions',
  subscriptionInfo = 'subscriptioninfo',
  usermanagement = 'usermanagement',
  addUser = 'adduser',
  refundrequests = 'refundrequests',
  confirmpricing = 'confirmpricing',
  paymentmethod = 'paymentmethod',
  ecreditspayment = 'ecreditspayment',
  subscriptionpaid = 'subscriptionpaid',
  consumercreated = 'consumercreated',
  invitations = 'invitations',
  businessSettings = 'businesssettings',
  businessDetails = 'details',
  addstore = 'addstore',
  myworldconnect = 'myworldconnect',
  dealerconnect = 'dealerconnect',
  dealerconnectSuccess = 'dealerconnect/success',
  dealerconnectError = 'dealerconnect/error',
  marketerconnectSuccess = 'marketerconnect/success',
  marketerconnectError = 'marketerconnect/error',
  accountSettings = 'account_settings',
  webWidget = 'webwidget',
  webWidgetProduction = 'production',
  webWidgetTesting = 'testing',
  webWidgetLogs = 'logs',
  ambassador = 'ambassador',
  profile = 'profile',
  profileCreate = 'create',
  profileSelect = 'select',
  createProfile = 'create_profile',
  onboarding = 'onboarding',
  sceMembership = 'scemembership',
  sceMembershipStatus = 'status',
  sceMembershipForm = 'form',
  sceMembershipDashboard = 'dashboard',
  sceMembershipGovernance = 'governance',
  sceMembershipVotings = 'votings',
  sceMembershipDelegates = 'delegates',
  sceMembershipDelegatesApplications = 'applications',
  sceMembershipDelegatesForm = 'application-form',
  business = 'business',
  priorityPoints = 'pp',
  airdrop = 'airdrop',
  unauthorized = 'unauthorized',
  invoice = 'invoice',
  priceSummary = 'pricesummary',
  consumerDetails = 'consumerdetails',
  profiles = 'profiles',
  webshopConfig = 'webshop_config',
  invitation = 'invitation',
  personal = 'personal',
  voucherVerification = 'voucher_verification',
  buyEcs = 'buyecs',
  deals = 'deals',
  createDeal = 'create_deal',
  editDeal = 'edit_deal',
  multiPayments = 'multi_payments',
  multiPaymentInfo = 'multi_payment_info',
  settings = 'settings',
  autologin = 'autologin',
  forbidden = 'forbidden',
}

export enum MaxFractionDigits {
  two = 2,
  three = 3,
  four = 4,
  five = 5,
  six = 6,
  seven = 7,
  eight = 8,
}

export enum SupportedLanguagesCodes {
  english = 'en-US',
  german = 'de-DE',
  italian = 'it-IT',
}

export enum SupportedLocalesCodes {
  unitedStates = 'us',
  german = 'de',
  italian = 'it',
  britain = 'en-gb',
  english = 'en',
}

export enum ExportTypes {
  csv = 'csv',
}

export enum ProcessedAuthCodes {
  unexpectedError = 400,
  notAuthenticated = 401,
  notAuthorized = 403,
  badRequest = 404,
  authenticationTimeout = 419,
  loginTimeout = 440,
  requestError = 0,
  requestConflict = 409,
  disconnect = 410,
}

export enum ApplicationFeatures {
  ambassador = 'Ambassador',
  webWidget = 'WebWidget',
  sceMembership = 'SCEMembership',
  businessOnBoarding = 'BusinessOnboarding',
  userInvitations = 'UserInvitations',
  subscriptions = 'Subscriptions',
  refundRequests = 'Refunds',
  userManagement = 'UserManagement',
  priorityPointsAirdrop = 'PriorityPointsAirdrop',
  receivePayments = 'ReceivePayments',
  eCSSubscriptionPayment = 'ECSSubscriptionPayment',
  mWSubscription = 'MWSubscription',
  instantTrade = 'InstantTrade',
  ethIntegration = 'ETHIntegration',
  deleteAccount = 'DeleteAccount',
  ecsSubscriptionPayment = 'ECSSubscriptionPayment',
  refundableAmount = 'RefundableAmount',
  mWDealerConnectDuringOnboarding = 'MWDealerConnectDuringOnboarding',
  sceDelegatesApplication = 'SceDelegatesApplication',
  voting = 'Voting',
  governance = 'Governance',
  mWMarketerConnect = 'MWMarketerConnect',
  invitationLinksV3 = 'InvitationLinksV3',
  simplexWeb = 'SimplexWeb',
  swipeluxWeb = 'SwipeluxWeb',
  deals = 'Deals',
  paymentRequestTemplates = 'PaymentRequestTemplates',
}

export enum SubscriptionNames {
  sceMembership = 'SCE Membership',
}

export enum InvitationStatus {
  pending = 'pending',
  accepted = 'accepted',
}
